<template>
    <div id="dashboard-content">
        <div class="row d-flex">
            <div class="col-lg-6 col-md-12 col-sm-12  order-lg-2 order-md-1 order-sm-2">
                <div class="border rounded position-relative p-3">
                    <div class="position-relative introTextContainer"></div>
                    <button class="report-footnotes-expand-button btn btn-primary btn-sm"  @click="showFullText = true">Read more</button>
                </div>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 order-lg-1 order-md-2 order-sm-1">
                <div class="charts-content">
                    
                <div class="chart-header mb-2 me-5" v-if="!drilldownActive"><i class="fas fa-chart-area"></i> Select a category from the table below to see the trend.</div>
                <div class="row">
                    <div class="col-lg-12">
                        <span class="category-name">{{ chartTitle }}</span>
                        <div v-if="chartLoading" class="loader chartLoader"></div>
                        <div class="chartLoadingContainer" v-if="chartReloading"><span class="loader chartLoader">Loading...</span></div>
                        <chart
                            v-if="chartData"
                            class="dashboard-content__line-chart"
                            :columnHeaders="columns"
                            :data="chartData"
                            :arraYears="arraYears"
                            :rowMetaData="rowMetaData"
                            :chartTitle="chartTitle"
                            ref="chart"
                        />
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div
            id="dashboard-tables"
            class="clearfix dashboard-tables-class mt-1"
            :class="(drilldownActive ? 'drilldown-active' : '') + ' ' + (loading ? 'loading' : '')"
        >
            <div id="table-main">

                <b-row class="mb-3 table-controls">
                    <b-col lg="6" md="12">
                        <b-row>
                            <b-col md="7" sm="12" class="mb-1">
                                <b-form-group
                                label="Filter"
                                label-for="filter-input"
                                label-cols-sm="0"
                                label-align-sm="right"
                                label-size="sm"
                                label-class="sr-only"
                                class="mb-0"
                                >
                                    <b-input-group size="md">
                                        <b-form-input
                                            id="filter-input"
                                            v-model="filterText"
                                            size="sm"
                                            type="search"
                                            placeholder="Filter Research/Disease Areas"
                                        ></b-form-input>

                                        <b-input-group-append>
                                            <b-button :disabled="!filterText" @click="filterText = ''" class="btn btn-secondary btn-sm">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col class="export-help-btn float-end">
                                <BDropdown v-model="show" text="Export" size="sm" :disabled="downLoadLoader" class="exportDropdown">
                                    <template #button-content> Export<i class="ms-1 fas fa-download"></i> </template>
                                    <BDropdownItem @click.prevent="exportCategoricalSpendingList()">Export Data as Excel</BDropdownItem>
                                    <BDropdownItem @click.prevent="exportChart()">Export Chart as Image</BDropdownItem>
                                </BDropdown>
                                <a href="categorical-spending/rcdc-process" class="help" aria-label="help">
                                    <i class="fas fa-question-circle help-icon"></i>
                                </a>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="12" lg="6">
                        <div class="overflow-auto float-end me-2" v-if="!this.mq.sm && !this.mq.xs && links.length > 0"  >
                            <BPagination v-model="currentFyRange" :total-rows="links.length * 1" :per-page="1" @page-click="changeColumns" size="sm" class="mt-4" 
                                first-text="<<" prev-text="<" next-text=">" last-text=">>" :limit="1">
                                <template #page="{page, active}" >
                                    <b v-if="active">{{ links[currentFyRange-1] }}</b>
                                </template>
                            </BPagination>

                        </div>
                    </b-col>
                </b-row>

                <v-table
                    :isActive="!drilldownActive"
                    :customId="'tableCS'"
                    v-if="!drilldownActive"
                    :isDrilldown="false"
                    :columns="selectedColumns"
                    :tableData="tableData"
                    ref="mainTable"
                    :filterText="filterText"
                    :isBusy="isTblBusy"
                    :rowMetaData="rowMetaData"
                    :class="isTblBusy ? 'isBusy' : ''"
                    :pageSize="tableData.length"
                    :filterOnColumns="filterOnCol"
                    tableName="categoricalSpending"
                />
                <template v-if="dataLoading">
                    <div class="loaderContainer">
                        <div class="loader"></div>
                    </div>
                </template>
            </div>

            <div id="table-drilldown">
                <h4 class="fw-bold">Data for Fiscal Year: {{ selectedFy.label }}</h4>

                <b-row class="mb-2">
                    <b-col class="my-1" lg="3" md="12">
                        <b-button class="me-2 ms-1" variant="primary" size="sm"
                            @click.prevent="back()"
                        >
                            Back
                        </b-button>
                        <BDropdown v-model="show" size="sm" :disabled="downLoadLoader" class="exportDropdown">
                            <template #button-content> Export<i class="ms-1 fas fa-download"></i> </template>
                            <BDropdownItem @click.prevent="exportProgramList()">Export Data as Excel</BDropdownItem>
                            <BDropdownItem @click.prevent="exportChart()">Export Chart as Image</BDropdownItem>
                        </BDropdown>
                    </b-col>
                    <b-col md="12" lg="9" class="my-1">
                        <div class="overflow-auto float-end">
                            <b-pagination
                                v-model="drillDownCurrentPage"
                                :total-rows="tableDataDrilldownLength"
                                :per-page="drillDownPerPage"
                                aria-controls="my-table" size="sm"
                                ></b-pagination>
                        </div>
                        <div class="me-3 row">
                            <template v-if="drillDownPerPage < tableDataDrilldownLength">
                                <div class="col-auto px-0">
                                    <b-form-group
                                        label="Showing"
                                        label-for="per-page-select"
                                        label-cols-sm="auto"
                                        label-cols-md="auto"
                                        label-cols-lg="auto"
                                        label-align-sm="right"
                                        label-size="md"
                                        class="mb-0 me-1"
                                        >
                                        <b-form-select
                                            id="per-page-select"
                                            v-model="drillDownPerPage"
                                            :options="drillDownPageOptions"
                                            size="sm"
                                            v-on:change="drillDownCurrentPage = 1"
                                        ></b-form-select>
                                    </b-form-group>
                                </div>
                                <span class="col-auto pt-2 px-0"> of {{ tableDataDrilldownLength }} projects</span>
                            </template>
                            <span class="col-auto pt-2" v-else-if="tableDataDrilldown && tableDataDrilldown.length > 0">Showing {{tableDataDrilldownLength}} of {{tableDataDrilldownLength}} projects</span>
                            <span class="col pt-2 fw-bold" v-if="isDrillDownFilterApplied">(filtered from {{ totalDrillDownDataLength }} projects)</span>
                        </div>
                    </b-col>
                </b-row>
                <v-table
                    :isActive="drilldownActive"
                    :customId="'tableCS-drilldown'"
                    :isDrilldown="true"
                    :columns="fieldListDrilldown"
                    :tableData="tableDataDrilldown"
                    :fundingICData="fundingICData"
                    :filterOnColumns="['ic']"
                    :filterText="filterText"
                    :isBusy="loading"
                    v-if="drilldownActive"
                    ref="drillDownTable"
                    :pageSize="drillDownPerPage"
                    :tablePageNo="drillDownCurrentPage"
                    tableName="programListing"
                />
            </div>
        </div>
        <footnotes v-if="!drilldownActive && reportAPIURLConfig" :reportAPIURLConfig="reportAPIURLConfig" />
        <div id="exportContainer"></div>
        <BModal id="textModal" title="Help" size="xl" v-model="showFullText" body-class="px-3" title-class="h5" ok-only ok-title="Close">
            <div class="introTextContainer">
            </div>
        </BModal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Chart from '@/components/global/Chart';
import Footnotes from '@/components/global/Footnotes';
import * as axios from 'axios';
import vTable from '@/components/global/_v-table';
import { BaseURL, RPTR_BASE_PROP_NAME, GET_SETTING_SUB_PATH } from "@/shared/config.js";
import bus from '@/shared/event-bus.js';


export default {
    name: 'DashboardContent',
    inject: ["mq"],
    components: {
        Chart,
        Footnotes,
        vTable
    },
    computed: {
        ...mapGetters([
            'barChartData',
        ]),
    },
    data: function () {
        return {
            chartTitle: null,
            chartData: null,
            rawData: null,
            selectedRowTitle: 0,
            activeColumn: null,
            columnHeaders: null,
            selectedColumns: [],
            columns: [
                { label: 'Research/Disease Areas \n(Dollars in millions and rounded)',
                    key: 'disease',
                    sortable: true,
                    class: 'diseaseCol',
                    displayOrder: 0,
                    display: true,
                    sortByFormatted: (value, key, item) => {
                        return `${item.disease.label}`;
                    },
                }
            ],
            tableData: [],
            sortField: 'DC_Name',
            sortDir: 1,
            links: [],
            currentFyRange: 1,
            fieldListDrilldown: [
                { label: 'Funding IC', key: 'ic', display: true, sortable: true },
                { label: 'Project Number', key: 'project_Number', urlField: 'appl_id', link: '/project-details/{{appl_id}}', display: true, sortable: true },
                { label: 'Sub Project #', key: 'subproject', display: true, sortable: true },
                { label: 'Project Title', key: 'project_Title', display: true, sortable: true },
                { label: 'PI Name', key: 'pI_Name', display: true, sortable: true },
                { label: 'Org Name', key: 'org', display: true, sortable: true },
                { label: 'State / Country', key: 'stateORCountry', display: true, sortable: true },
                { label: 'Amount', key: 'amount', type: 'currency', display: true, sortable: true, formatter: value => {
                        return window.filters.formatGlobal(value, 'currency');
                }}
            ],
            tableDataDrilldown: [],
            tableDataDrilldownLength: 0,
            isFilteredData: false,
            fundingICData:[],
            sortFieldDrilldown: 'FY',
            sortDirDrilldown: 1,

            drilldownActive: false,
            loading: false,
            dataLoading: false,
            chartLoading: false,
            noDrillDownData: false,
            selectedFy: '',
            selectedCategory: null,
            baseReporterURL: '',
            reportAPIURLConfig: null,
            apiPrefix: '',
            footNoteData: null,
            downLoadLoader: false,
            downloadErr: null,
            arraYears: [],
            rowMetaData: [],
            selectedRowId: null,
            filterText: '',
            currentPage: 1,
            filterOnCol: [],
            colsPerView: 6,
            isTblBusy: false,
            drillDownPageOptions: [100],
            drillDownPerPage: 100,
            drillDownCurrentPage: 1,
            slideSpeed: 705,
            chartReloading: false,
            source: null,
            isDrillDownFilterApplied: false,
            totalDrillDownDataLength: null,
            showFullText: false,
            show: false
        };
    },
    async mounted() {
        if (window.location.pathname.indexOf('/categorical-spending') !== -1 || window.location.hostname === 'localhost') {
            this.getReporterUrl();
            this.reportAPIURLConfig = `${BaseURL}/api`;
            this.dataLoading = true;
            this.chartLoading = true;
            this.isTblBusy = true;

            var response = await axios.get(encodeURI(`${BaseURL}/api/CategoricalSpendingConfig` + this.apiPrefix)),
                catResponse,
                $this = this,
                configData,
                itemToReplaced, nonARRAColInd,
                cssClasses = ['align-middle'];

            if (response && response.status === 200) {
                configData = response.data;

                for (let i = 0; i < configData.length; i++) {
                    if (configData[i].display) {
                        $this.columns.push({
                            label: configData[i].display_Name.trim(),
                            key: configData[i].fY_Dataset,
                            sortable: true,
                            type: configData[i].data_Type,
                            drilldownLink: configData[i].is_Linkable,
                            displayOrder: configData[i].display_Order,
                            isPrevalence: configData[i].is_Prevalence,
                            isMortality: configData[i].is_Mortality,
                            isARRA: configData[i].is_ARRA,
                            footnoteID: configData[i].footnote_ID,
                            isEstimated: configData[i].is_Estimated,
                            display: configData[i].display,
                            class: cssClasses,
                            formatter: value => {
                                return window.filters.formatGlobal(value, configData[i].data_Type);
                            }
                        });
                        if (!configData[i].is_Prevalence && !configData[i].is_Mortality && !configData[i].is_Estimated) {
                            if (!configData[i].is_ARRA) {
                                itemToReplaced = $this.arraYears.filter(element => element.key.includes(configData[i].fY_Dataset.match(/\d+/).join("")));
                                if (itemToReplaced.length === 0) {
                                    $this.arraYears.push({
                                        key: configData[i].fY_Dataset,
                                        isARRACol: false
                                    });
                                }
                            }
                            else {
                                itemToReplaced = $this.arraYears.filter(element => element.key.includes(configData[i].fY_Dataset.match(/\d+/).join("")));
                                nonARRAColInd = $this.arraYears.indexOf(itemToReplaced[0]);
                                if (nonARRAColInd !== -1) {
                                    $this.arraYears[nonARRAColInd].key = configData[i].fY_Dataset;
                                    $this.arraYears[nonARRAColInd].isARRACol = true;
                                } else {
                                    $this.arraYears.push({
                                        key: configData[i].fY_Dataset,
                                        isARRACol: true
                                    });
                                }
                            }
                        }
                    }
                }

                this.columns = _.sortBy(this.columns, ['displayOrder']);
                this.buildNavLinks();
            }

            catResponse = await axios.get(encodeURI(`${BaseURL}/api/CategoricalSpendings` + this.apiPrefix));

            if (catResponse && catResponse.status === 200) {
                this.dataLoading = false;
                this.chartLoading = false;
                this.rawData = catResponse.data;

                this.tableData = this.parseData(catResponse.data);
                this.$nextTick(() => {
                    if (this.$refs && this.$refs.mainTable) {
                        this.$refs.mainTable.selectThisRow(0);
                    }
                    this.setChartData(this.tableData[0].disease.label);
                });
            }
            this.isTblBusy = false;

            window.addEventListener('resize', function () {
                setTimeout(() => {
                    $this.buildNavLinks();

                    if ($this && $this.$refs) {
                        if ($this.$refs.chart) {
                            try {
                                $this.$refs.chart.resizeChart();
                            } catch (err) {

                            }
                        }
                        if ($this.$refs && $this.$refs.mainTable) {
                            bus.$emit('set:tableSort');
                        }
                    }
                }, this.slideSpeed);
            });

            bus.$on('table:filtered', (drilldownData, isFiltered) => {
                this.drillDownCurrentPage = 1;
                this.tableDataDrilldownLength = drilldownData.length;
                this.isFilteredData = isFiltered;
            });

            bus.$on('load:chartDataByFunding', async (fundingIcs) => {
                this.chartReloading = true;
                this.isDrillDownFilterApplied = false;
                let chartData = [];
                if (fundingIcs.length != 0 && fundingIcs.length < this.fundingICData.length) {
                    this.isDrillDownFilterApplied = true;
                   chartData = await this.getChartDataByFundingIc(fundingIcs);
                } else {
                    chartData = [];
                    if (fundingIcs.length != 0) {
                        this.setChartData( this.selectedCategory.dC_Name);
                    }
                    this.chartReloading = false;
                }
                if (chartData !== undefined) {
                    if (fundingIcs.length == this.fundingICData.length) {
                        fundingIcs = [];
                    }
                    bus.$emit('chart:reloadForFundingIC', chartData, fundingIcs);
                    this.chartReloading = false;
                }
            });
        }
    },
    methods: {
        async getChartDataByFundingIc (fundingIc) {
            try {
                if(this.source){
                    this.source.cancel();
                }
                const CancelToken = axios.CancelToken;
                this.source = CancelToken.source();

                let response = await axios.get(encodeURI(`${BaseURL}/api/projectListing/listingByFundingIc?CategoryID=` + this.selectedCategory.category_ID + `&funding=` + fundingIc), {
                    cancelToken: this.source.token
                }).catch(function(thrown) {
                    if (axios.isCancel(thrown)) {
                        console.log('Request canceled', thrown.message);
                    } else {
                        console.log("cancel error")
                    }
                    return [];
                });
                if (response && response.status == 200) {
                    let data = response.data;
                    return data;
                }

            } catch (err) {
                console.log(err);
            }
        },
        getReporterUrl() {
            var xhr;
        
            xhr = new XMLHttpRequest();
            var url,
                requestType = 'GET',
                $this = this;

            url = BaseURL + GET_SETTING_SUB_PATH + RPTR_BASE_PROP_NAME;

            xhr.open(requestType, url, true);

            xhr.onload = function () {
                if (xhr.status === 200) {
                    $this.baseReporterURL = xhr.responseText;
                }
            };
            xhr.send();
        },
        linkGen() {
            return '';
        },
        pageGen(pageNum) {
            return this.links[pageNum - 1];
        },
        buildNavLinks() {
            this.links = [];
            if (this.mq.sm || this.mq.xs) {
                    this.colsPerView = this.columns.length;
                    this.columns = _.map(this.columns, function (item) {
                        item.cssClasses = ['align-middle'];
                        return item;
                    });
            } else if (this.mq.md) {
                    this.columns = _.map(this.columns, function (item) {
                        item.cssClasses = ['align-middle', 'text-end'];
                        return item;
                    });
                    this.colsPerView = 6;
            } else if (this.mq.lg) {
                    this.columns = _.map(this.columns, function (item) {
                        item.cssClasses = ['align-middle', 'text-end'];
                        return item;
                    });
                    this.colsPerView = 9;
            } else {
                    this.columns = _.map(this.columns, function (item) {
                        item.cssClasses = ['align-middle', 'text-end'];
                        return item;
                    });
                    this.colsPerView = 12;
            }
            let variableCols = this.colsPerView - 1;

            for (let i = 1; i < this.columns.length - variableCols; i++) {
                this.links.push(this.columns[i].label + ' - ' + this.columns[i + variableCols].label);
            }
            this.currentFyRange = this.links.length;
            this.onColumnsChanged(null, this.currentFyRange);
        },
        changeColumns(evt, page) {
            $(".scroll-table-container.b-table-sticky-header div.table-bg-row").hide();
            this.isTblBusy = true;
            var $this = this;

            setTimeout(() => {
                $this.onColumnsChanged(evt, page);
            });
        },
        onColumnsChanged(evt, page) {
            this.selectedColumns = [];
            var copiedCols = _.sortBy(this.columns, ['displayOrder']),
                startCnt = page,
                endCnt = startCnt + this.colsPerView,
                $thisObj = this;

            startCnt = startCnt == 0 ? 1 : startCnt;
            this.filterOnCol = copiedCols[0].key.split();

            endCnt = (endCnt > copiedCols.length) ? copiedCols.length : endCnt;
            this.selectedColumns.push(copiedCols[0]);
            for (let i = startCnt; i < endCnt; i++) {
                this.selectedColumns.push(copiedCols[i]);
            }
            this.$nextTick(() => {
                bus.$emit('set:tableSort');
            });
            if (evt) {
                setTimeout(() => {
                    $thisObj.isTblBusy = false;
                }, this.slideSpeed);
            }
        },

        back() {
            var $this = this;

            $this.dataLoading = true;
            $this.drilldownActive = false;
            $this.$nextTick(() => {
                this.setChartData( this.selectedCategory.dC_Name);
                bus.$emit('reset:selectedFundingIcs');
                $this.downloadErr = null;
                setTimeout(() => {
                    if ($this.$refs && $this.$refs.mainTable) {
                        bus.$emit('set:tableSort');
                    }
                    $this.dataLoading = false;
                }, this.slideSpeed);
            });
        },

        parseData(data) {
            let parsedData = [],
                amt,
                row;

            for (let i = 0; i < data.length; i++) {
                row = {};

                row['disease'] = {
                    label: data[i].dC_Name,
                    footNoteNum: data[i].footnote_Num
                };

                if (i === 0) {
                    this.rowMetaData.push({
                        label: data[i].dC_Name,
                        footNoteNum: data[i].footnote_Num
                    });
                }

                for (let ind = 1; ind < this.columns.length; ind++) {
                    for (let j = 0; j < data[i].data.length; j++) {
                        if (this.columns[ind].key === data[i].data[j].fY_Dataset) {
                            if (this.columns[ind].isPrevalence) {
                                amt = data[i].data[j].amount;
                            } else {
                                amt = !data[i].data[j].amount ? null : Math.round(data[i].data[j].amount);
                            }
                            if (i === 0) {
                                this.rowMetaData.push({
                                    isARRA: this.columns[ind].isARRA,
                                    key: this.columns[ind].key,
                                    isEstimated: this.columns[ind].isEstimated,
                                    isMortality: this.columns[ind].isMortality,
                                    isPrevalence: this.columns[ind].isPrevalence,
                                    display: this.columns[ind].display
                                });
                            }
                            row[this.columns[ind].key] = amt;
                            break;
                        }
                    }
                }

                parsedData.push(row);
            }

            return parsedData;
        },

        getCategoryIndex(category) {
            for (let i = 0; i < this.tableData.length; i++) {
                if (category === this.tableData[i].disease.label) {
                    return i;
                }
            }
        },

        setChartData(name) {
            // get actual data index, since table index
            // changes when data is filtered
            let dataIndex = this.getCategoryIndex(name);

            this.selectedRowTitle = name;

            this.chartData = copyData(this.tableData[dataIndex]);

            this.chartTitle = name;
        },

        async exportProgramList() {
            try
            {
                this.downloadErr = null;
                var fy = this.selectedFy.key.match(/\d+/).join(""),
                    arra = !this.selectedFy.isARRA ? 'N' : 'Y',
                    downloadButton = document.createElement('a');

                const response = await axios.get(encodeURI(`${BaseURL}/api/ProjectListingExport?FY=` + fy + `&CategoryID=` + this.selectedCategory.category_ID + '&ARRA=' + arra));

                if (response.status !== 200) {
                    throw Error(response.message);
                }
                if (!response.data) {
                    return null;
                }

                downloadButton.setAttribute('href', `${BaseURL}/api/Download?path=files&filename=` + response.data);
                downloadButton.setAttribute('download', response.data);
                downloadButton.setAttribute('id', 'export-download');
                downloadButton.setAttribute('style', 'opacity: 0;');

                document.body.appendChild(downloadButton);
                downloadButton.click();
                downloadButton.parentElement.removeChild(downloadButton);
            } catch (error) {
                this.downloadErr = "Could not download file. Please try again later";
                console.error(error);
                return [];
            }
        },

        async exportCategoricalSpendingList() {
            try
            {
                this.downloadErr = null;
                const response = await axios.get(encodeURI(`${BaseURL}/api/categoricalspendingexport`));

                if (response.status !== 200) {
                    throw Error(response.message);
                }
                if (!response.data) {
                    return null;
                }
                var downloadButton = document.createElement('a');

                downloadButton.setAttribute('href', `${BaseURL}/api/Download?path=files&filename=` + response.data);
                downloadButton.setAttribute('download', response.data);
                downloadButton.setAttribute('id', 'export-download');
                downloadButton.setAttribute('style', 'opacity: 0;');

                document.body.appendChild(downloadButton);
                downloadButton.click();
                downloadButton.parentElement.removeChild(downloadButton);
            } catch (error) {
                this.downloadErr = "Could not download file. Please try again later";
                console.error(error);
                return [];
            }
        },

        async loadDataDrilldown({
            column: column,
            category: category
        }, selectedRowId) {
            let categoryObject = this.rawData.filter((item) => {
                if (item.dC_Name === category) {
                    return item;
                }
            })[0],
                fy = column.key.match(/\d+/).join(""),
                arra = !column.isARRA ? 'N' : 'Y';

            this.loading = true;
            this.noDrillDownData = false;
            this.selectedFy = column;
            this.selectedCategory = categoryObject;
            this.selectedRowId = selectedRowId;
            this.isTblBusy = true;

            const response = await axios.get(encodeURI(`${BaseURL}/api/projectListing` + this.apiPrefix + `?FY=` + fy + `&CategoryID=` + categoryObject.category_ID + `&ARRA=` + arra));

            if (response && response.status === 200)
            {
                //window.scrollTo(0, $('#dashboard-content').offset().top);

                this.drillDownPageOptions = [];
                this.drillDownPerPage = 100;
                this.drillDownCurrentPage = 1;
                this.drilldownActive = true;
                this.isTblBusy = false;
                if (response.data.length > 500 && response.data.length <= 1000) {
                    this.drillDownPageOptions = [50, 100, 300, 500];
                } else if (response.data.length > 1000) {
                    this.drillDownPageOptions = [50, 100, 300, 500, 1000];
                } else {
                    this.drillDownPageOptions = [50];
                    this.drillDownPerPage = 50;
                    if (response.data.length > 100) {
                        this.drillDownPageOptions = [50, 100];
                    }
                }
                this.tableDataDrilldown = response.data;
                this.tableDataDrilldownLength = this.tableDataDrilldown.length;
                this.totalDrillDownDataLength = this.tableDataDrilldown.length;
                this.fundingICData = _.uniq(_.map(this.tableDataDrilldown, (item) => {
                    return item.ic;
                }));

                this.fundingICData = _.sortBy(this.fundingICData);
                this.loading = false;
                bus.$emit('set:tableSort');
            } else {
                this.loading = false;
                this.noDrillDownData = true;
            }
        },

        setDrillDownLoading() {
            this.loading = true;
        },

        hideLoader() {
            var $this = this;

            setTimeout(() => {
                $this.loading = false;
                $this.isTblBusy = false;
            }, this.slideSpeed);
        },

        exportChart () {
            bus.$emit('chart:export');
        }
    }
};
</script>

<style lang="scss" scoped>

@import '@/scss/variables.scss';
#dashboard-content {
    width: 100%;
    margin: 0 auto;
    padding: $home-page-padding 0;
    transition: 0.5s;
    max-width: 1400px;
    overflow: hidden;
    font-size: 16px;
}

#dashboard-tables, .dashboard-tables-class {
    position: relative;

    &.drilldown-active {

        #table-main {
            opacity: 0;
            width: 0;
            height: 0;
            transition: opacity 0.5s ease-out 0.001s, width 0 ease-out 0.3s, height 0.3s ease-out 0.3s;
            .table-controls, .chart-note {
                display: none;
            }
        }

        #table-drilldown {
            opacity: 1;
            transition: opacity 0.5s ease-out 0.001s, width 0.001s ease-out 0.001s, height 0.001s ease-out 0.001s;
            height: 100%;
            width: 100%;
        }
        &.loading {
            .loader {
                left: 75%;
                top: 3%;
            }
        }
    }

    .loader {
        left: calc(25% - 5em);
    }


    #table-main {
        opacity: 1;
        transition: opacity 0.5s ease-out 0.001s, width 0.001s ease-out 0.001s, height 0.001s ease-out 0.001s;
        height: 100%;
        width: 100%;
        .table-controls, .chart-note {
            display: flex;
        }
    }

    #table-drilldown {
        opacity: 0;
        width: 0;
        height: 0;
        transition: opacity 0.5s ease-out 0.001s, width 0 ease-out 0.3s, height 0.3s ease-out 0.3s;
    }
}

.dashboard-content__line-chart {
    width: 100%;
    height: 100%;
    min-height: 200px;
}
// $chart-content-padding: 15px;
$chart-content-padding: 0;

.charts-content {
    position: relative;
    // background-color: white;
    // border-radius: 5px;
    // -webkit-box-shadow: 0 0 10px #d4d7df;
    // box-shadow: 0 0 10px #d4d7df;
    padding: 10px $chart-content-padding 0px;
    // padding-bottom: 12px;
    margin-bottom: 25px;
    &.bar-charts {
        margin-top: 32px;
    }
    .col-lg-12 {
        min-height: 100px;
        .loader {
            top: calc(50% - 50px);
            &.chartLoader {
                top: calc(50%);
            }
        }

    }
}

.page-link {
    padding: 0.5rem;
}
#per-page-select {
    margin-top: 5px;
}

.chart-note {
    font-weight: 700;
    color: #555;
}
.pagination {
    margin-bottom: 0 !important;
    margin-top: 0 !important;
    .page-item {
        border-radius: 0 !important;
        &.disabled {
            .page-link {
                background-color: #ececec;
                opacity: 0.5;
            }
        }
    }
}
.loaderContainer {
    .loader {
        top: unset;
    }
}
.error-message {
    color: #cc4545;
    font-weight: 500;
    border-radius: 4px;
    margin: 0 10px;
    vertical-align: bottom;
}
.chartLoadingContainer {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background-color: #a0a0a0;
    opacity: .3;
    top: 15px;
}
#exportContainer {
    visibility: hidden;
}
.exportDropdown {
    z-index: 1003;
}
.chart-header {
    background-color: #fff2cd;
    padding: 7px 15px;
    border-radius: 7px;
    color:#000;
    font-weight: bold;
}
</style>
